import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProgressService {
  private readonly byFileId = new Map<string, Subject<number>>();

  emit(fileId: string, pct: number): void {
    let subject = this.byFileId.get(fileId);
    if (!subject) {
      subject = new Subject<number>();
      this.byFileId.set(fileId, subject);
    }
    subject.next(pct);
  }

  watch(fileId: string): Observable<number> {
    let subject = this.byFileId.get(fileId);
    if (!subject) {
      subject = new Subject<number>();
      this.byFileId.set(fileId, subject);
    }
    return subject.asObservable();
  }

  clear(fileId: string): void {
    const subject = this.byFileId.get(fileId);
    if (subject) {
      subject.complete();
      this.byFileId.delete(fileId);
    }
  }
}
